export default __webpack_public_path__ + "static/media/icon-clock-small-selected.95f7f9a9.svg";